import { Select, TreeSelect } from "antd";
import React, { forwardRef } from "react";
import MultiSelectDropdown from "../../dropdowns/MultiSelectDropdown";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control"];
  if (touched && errors) {
    classes.push("is-invalid-select");
  }

  if (touched && !errors) {
    classes.push("is-valid-select");
  }

  return classes.join(" ");
};

export const SelectInput = forwardRef(({
  label,
  withFeedbackLabel = false,
  customFeedbackLabel,
  children,
  errors,
  touched,
  onChange = false,
  isRequired = false,
  defaultValue = null,
  value = "",
  options = [],
  showSearch = true,
  disabled = false,
  mode = "single",
  size = "middle",
  allowClear = true,
  placeholder = "Option",
  name,
  ...props
}, ref) => {
  switch (mode) {
    case "single":
      return (
        <div className="form-group">
          {label && (
            <label className={isRequired ? "required" : ""}>{label}</label>
          )}
          <Select
            ref={ref}
            style={{
              width: "100%",
              minHeight: "42px",
              background: disabled ? "#f5f5f5 !important" : "white !important",
              ...(errors ? { border: "1px solid red" } : {})
            }}
            mode={mode}
            // status={errors ? "error" : null}
            onChange={onChange}
            options={options}
            className={getFieldCSSClasses(touched, errors)}
            value={!value || value == "" ? undefined : value}
            disabled={disabled}
            placeholder={
              placeholder && placeholder !== "Option"
                ? placeholder
                : typeof label === "string"
                  ? `Select ${label}`
                  : "Select Option"
            }
            maxTagCount="responsive"
            size={size}
            allowClear={allowClear}
            showSearch={showSearch}
            filterOption={(inputValue, option) =>
              option.label?.toLowerCase().indexOf(inputValue.toLowerCase()) !==
              -1
            }
            {...props}
          />
          {withFeedbackLabel && (
            <FieldFeedbackLabel
              erros={errors}
              touched={touched}
              label={label}
              customFeedbackLabel={customFeedbackLabel}
            />
          )}
        </div>
      );

    case "tags":
      return (
        <div className="form-group">
          {label && (
            <label className={isRequired ? "required" : ""}>{label}</label>
          )}
          <Select
            ref={ref}
            style={{
              width: "100%",
              minHeight: "42px",
              ...(errors ? { border: "1px solid red" } : {})
            }}
            mode={mode}
            status={errors ? "error" : null}
            onChange={onChange}
            options={options}
            className={getFieldCSSClasses(touched, errors)}
            value={!value || value == "" ? undefined : value}
            disabled={disabled}
            placeholder={placeholder ? placeholder : `Select ${label}`}
            maxTagCount="responsive"
            allowClear={allowClear}
            showSearch={showSearch}
            filterOption={(inputValue, option) =>
              option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !==
              -1
            }
            {...props}
          />
          {withFeedbackLabel && (
            <FieldFeedbackLabel
              erros={errors}
              touched={touched}
              label={label}
              customFeedbackLabel={customFeedbackLabel}
            />
          )}
        </div>
      );

    case "tree":
      return (
        <div className="form-group">
          {label && (
            <label className={isRequired ? "required" : ""}>{label}</label>
          )}
          <TreeSelect
            ref={ref}
            style={{
              width: "100%",
              minHeight: "42px",
              ...(errors ? { border: "1px solid red" } : {})
            }}
            status={errors ? "error" : null}
            onChange={onChange}
            treeData={options}
            value={!value || value == "" ? undefined : value}
            disabled={disabled}
            allowClear={allowClear}
            placeholder={`Select ${label}`}
            showSearch={showSearch}
            size="small"
          />
          {withFeedbackLabel && (
            <FieldFeedbackLabel
              erros={errors}
              touched={touched}
              label={label}
              customFeedbackLabel={customFeedbackLabel}
            />
          )}
        </div>
      );

    case "multiple":
      return (
        <div>
          {label && (
            <label className={isRequired ? "required" : ""}>{label}</label>
          )}
          <MultiSelectDropdown
            ref={ref}
            status={errors ? "error" : null}
            onChange={onChange}
            value={value ?? []}
            disabled={disabled}
            options={options ?? []}
            placeholder={label}
          />
        </div>
      );

    default:
      break;
  }
})
